'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css2 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButton = _radio2.default.Button;
var RadioGroup = _radio2.default.Group;
var Search = _input2.default.Search;

var ProductFilter = _react2.default.createClass({
  displayName: 'ProductFilter',

  propTypes: {
    status: _react.PropTypes.arrayOf(_react.PropTypes.object.isRequired).isRequired,
    types: _react.PropTypes.arrayOf(_react.PropTypes.object.isRequired).isRequired,
    filter: _react.PropTypes.object.isRequired,
    onChange: _react.PropTypes.func.isRequired
  },
  onStatusChange: function onStatusChange(e) {
    this.props.onChange('status', e.target.value);
  },
  onTypeChange: function onTypeChange(e) {
    this.props.onChange('type', e.target.value);
  },
  onKeywordChange: function onKeywordChange(keyword) {
    this.props.onChange('keyword', keyword);
  },
  render: function render() {
    var _props$filter = this.props.filter,
        type = _props$filter.type,
        status = _props$filter.status,
        keyword = _props$filter.keyword;

    return _react2.default.createElement(
      'div',
      { className: 'filter' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          '\u5546\u54C1\u7C7B\u578B\uFF1A'
        ),
        _react2.default.createElement(
          RadioGroup,
          { onChange: this.onTypeChange, value: type },
          _react2.default.createElement(
            RadioButton,
            { value: -1 },
            '\u5168\u90E8'
          ),
          this.props.types.map(function (type) {
            return _react2.default.createElement(
              RadioButton,
              { key: type.id, value: type.id },
              type.name
            );
          })
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          '\u5546\u54C1\u72B6\u6001\uFF1A'
        ),
        _react2.default.createElement(
          RadioGroup,
          { onChange: this.onStatusChange, value: status },
          _react2.default.createElement(
            RadioButton,
            { value: -1 },
            '\u5168\u90E8'
          ),
          this.props.status.map(function (state) {
            return _react2.default.createElement(
              RadioButton,
              { key: state.id, value: state.id },
              state.name
            );
          })
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'label',
          null,
          '\u5173\u952E\u8BCD\uFF1A\xA0\xA0\xA0\xA0'
        ),
        _react2.default.createElement(Search, { defaultValue: keyword,
          placeholder: '\u5546\u54C1\u540D\u79F0\u7B49\uFF0C\u6309\u56DE\u8F66\u952E\u641C\u7D22',
          onSearch: this.onKeywordChange
        })
      )
    );
  }
});

exports.default = ProductFilter;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/product_filter.js
// module id = 1479
// module chunks = 0